export type ClerkTokenGetter = (options?: { template?: string }) => Promise<string | null>;

/**
 * Prefer the Intelligenic Clerk template token for backend/RBAC routes, but
 * fall back to the default session token when the template is unavailable in
 * local/dev environments.
 */
export async function getIntelligenicToken(getToken: ClerkTokenGetter): Promise<string> {
    const templated = await getToken({ template: "Intelligenic" });
    if (templated) return templated;
    return (await getToken()) ?? "";
}
